import { MenuIdPeople } from '@jira/navigation-apps__constants/src/MenuIdPeople.tsx';
import { getAutomationDiscoveryDismissResource } from '@jira/router-resources__eoc-alert-detail/src/getAutomationDiscoveryDismissResource.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { resourceWithCondition } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { LazyTeamDashboardSidebar } from '@jira/navigation-apps__sidebar-eoc-team-dashboard/src/async.tsx';
import { opsTeamLayout } from '@jira/platform__layouts-ops-team-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { eocTeamAlertDetailRoute } from '@jira/router-routes__eoc-team-alerts-routes/src/eocTeamAlertDetailRoute.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { resources as teamDashboardResources } from '@atlassian/eoc-team-dashboard/resources';
import { resources as alertListResources } from '@atlassian/eoc-alert-list/resources';
import { resources as alertDetailResources } from '@atlassian/eoc-alert-detail/resources';
import type { Route, RouteResources } from '@atlassian/react-resource-router';
import AlertList, { LazyAlertList } from './ui/spa/eoc/alert-list/index.tsx';

export const eocTeamAlertDetailRouteEntry: Route = createEntry(eocTeamAlertDetailRoute, () => ({
	group: 'eoc',
	// eslint-disable-next-line no-restricted-syntax
	component: AlertList,
	layout: opsTeamLayout,

	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	resources: [
		...getNavigationResources(),
		...teamDashboardResources(),
		...alertListResources(),
		...alertDetailResources(),
		getConsolidationStateResource(),
		resourceWithCondition(
			() => fg('automation_discoverability_in_jsm'),
			getAutomationDiscoveryDismissResource,
		),
	] as RouteResources,

	navigation: {
		menuId: MenuIdPeople,
	},

	forPaint: [LazyAtlassianNavigation, LazyAlertList, LazyTeamDashboardSidebar],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
